import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {useWsMemberStore} from "@domains/settings/stores/workspace-member.store";
import {useWorkspaceStore} from "@shared/stores/workspace.store";

export const getMemberDetailsResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {

    const wsMemberStore = useWsMemberStore();
    const wsStore = useWorkspaceStore();
    const workspaceId = wsStore.getSelectedWorkspaceId;
    const {memberId} = to.params;

    wsMemberStore.loadMemberDetails(workspaceId, Number(memberId)).then(() => next())

};
